import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../button/button';

interface Props {
  url?: string;
  onUrlOpenClicked: (url: string) => void;
}

const LinkActions = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Component>
      <Button
        disabled={!props.url}
        variant="contained"
        onClick={() => navigator.clipboard.writeText(props.url!)}
      >
        {t('accessTokens.linkActions.copyLink', { ns: 'components' })}
      </Button>
      <Button
        disabled={!props.url}
        variant="contained"
        onClick={() => props.onUrlOpenClicked(props.url!)}
      >
        {t('accessTokens.linkActions.openLinkInIframe', { ns: 'components' })}
      </Button>
    </Component>
  );
};

const Component = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-grow: 1;
  gap: 10px;
`;

export { LinkActions };
